import React from 'react';
import './App.css';
import CustomNavbar from './components/CustomNavBar'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import watch1 from './Images/GarminWatchApp.png';
import watch1_thumb from './Images/GarminWatchApp_thumb.png';
import ImageGallery from 'react-image-gallery';
import logo from './Images/TrueNorth_garmin.png';
import CustomBtn from './components/CustomButton'
import  { FirebaseContext } from "./components/Firebase";
import Button from '@material-ui/core/Button';
import MLink from '@material-ui/core/Link';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';

//function App() {

let INITIAL_STATE = {};

class TrueNorthSALogin extends React.Component {
    constructor(props) {
        super(props);
  
        INITIAL_STATE = {
          password: '',
          email: '',
          error: null,
        };
        
        this.state = { ...INITIAL_STATE };
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
      };

    onSubmit = () => {
    const {password, email} = this.state;

    };

render() {

    const boxStyle = { 
        maxWidth:'95%',
        width: 'fit-content', 
        background:'rgba(181, 181, 181, 0.07)', 
        borderRadius:'3px', 
        padding:'15px', 
        margin: '45px 5px 25px 5px',
        boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)'
    };

    const inputBox = {
        border: '1.5px solid #000000',
        borderRadius: '3px',
        minWidth: '250px',
        padding: '10px',
        background: 'rgba(255, 255, 255, 0.01)',
        marginTop:'10px',
    };

      const {
        password,
        email,
        error
      } = this.state;
  
      const isInvalid =
        email === '' ||
        password === '';

  return (

    <div style={{height:'100%'}}>
    <div style={{minHeight:'92vh'}}>
    <CustomNavbar logo={true}></CustomNavbar>

    <Grid container direction="column" justify={'center'} alignItems={'center'} style={{ height:'100%'}}>
                <Grid container direction="column" justify={'center'} alignItems={'center'} style={boxStyle}>
                <img src={logo} style={{maxWidth: '250px', margin:'10px'}}/>
                <Typography variant="subtitle1" style={{marginTop:'15px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                    LOGIN TO SAIL ANALYSIS
                </Typography>
                <input
                    name="email"
                    value={email}
                    onChange={this.onChange}
                    type="text"
                    placeholder="Email"
                    style={inputBox}
                    />
                <input
                    name="password"
                    value={password}
                    onChange={this.onChange}
                    type="password"
                    placeholder="Password"
                    style={inputBox}
                />


                <form onSubmit={this.onSubmit}>
                    <Button variant="contained" disabled={isInvalid} color="primary" style={{marginTop:'15px'}} type="submit">
                       LOGIN
                    </Button>
                    {error && <p>{error.message}</p>}
                </form>
                </Grid>
            </Grid>
    </div>

    <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
    <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
    <Typography variant="body2" style={{color:'white', textAlign: 'center'}}>
                  Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
    </Typography>
    </Grid>
    </div> 


    </div>
    );
  }
}

export default TrueNorthSALogin;